/* eslint-disable max-len */
/* eslint-disable consistent-return */
import React, { ChangeEvent, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import {
  ContentState,
  EditorState,
} from 'draft-js';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { stateToHTML } from 'draft-js-export-html';
import { Editor } from 'react-draft-wysiwyg';
import htmlToDraft from 'html-to-draftjs';
import { AxiosError } from 'axios';
import { Input, InputAdornment, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import ComponentTextInput from '../../../Common/ComponentTextinput/ComponentTextInput';
import { showErrorToaster, showSuccessToaster } from '../../../Common/ComponentToast/ComponentSuccessToasts';
import localStorageConstants from '../../../utils/LocalStorageConstants';
import Config from '../../../Common/Config';
import { setLoader } from '../../../redux/loaderSlice';
import { AttachmentIcon } from '../../../assets/TableIcons/AttachmentIcon';
import { OilReportEmailResponse } from '../../../Common/OilReportEmailModal/TypeOilReportEmailModal';
import { customOptions } from '../../../Common/TextEditorOptions';
import { makeFormPostRequest } from '../../../Common/NetworkOps';
import { RootState } from '../../../redux/rootState';
import { DoubleArrowBlackIcon } from '../../../assets/TableIcons/DoubleArrowBlackIcon';
import { DoubleArrowGreenIcon } from '../../../assets/TableIcons/DoubleArrowGreenIcon';
import { CheckedIcon, SelectedCheckBoxIcon } from '../../../assets/TableIcons';
import { getCustomerContactList } from '../../oilReport/redux/oilReportSlice';
import { ConfirmationIcon } from '../../../assets/Icons/AnalystIcons/ConfirmationIcon';
import ConfirmationModal from '../../../Common/ConfirmationModal/ConfirmationModal';
import english from '../../../assets/lang/english';

type ModalProps = {
  show: boolean;
  handleClose: () => void;
  // downloadPdf: () => Promise<File | null | undefined>;
};
interface DataInterface {
  Name: string,
  Email: string,
  OilReport: boolean,
  EctReport: boolean,
  Id: number,
}
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '65%',
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: '6px 24px 24px 24px',
  '@media (max-width: 1200px)': {
    width: '65%',
  },
  '@media (max-width: 768px)': {
    width: '65%',
    height: 'auto',
    p: 2,
  },
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

function BidPdfEmailConfirmationModal({
  show, handleClose,
  // downloadPdf,
}: ModalProps) {
  const {
    control, getValues, setValue,
  } = useForm();
  const dispatch = useDispatch();
  const [data, setData] = useState<DataInterface[]>([]);
  const [fileValidationModal, setFileValidationModal] = useState<boolean>(false);
  const [sendMailLoading, setSendMailLoading] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState<File | null>(null);
  const [comment, setComment] = useState(EditorState.createEmpty());
  const { bidPdfDetailsData } = useSelector((state: RootState) => state.bidPdfSliceReducer);
  const { userProfile } = useSelector((state: RootState) => state.userProfileReducer);
  const { CustomerContactList, isContactLoading } = useSelector((state: RootState) => state.oilReportReducer);
  const [allReceiverEmails, setAllReceiverEmails] = useState<string[]>([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (isContactLoading || sendMailLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
  }, [sendMailLoading, isContactLoading]);

  const htmlToEditorState = (html: string): EditorState => {
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  };

  useEffect(() => {
    setValue('Subject', `${bidPdfDetailsData?.SiteName} (${bidPdfDetailsData?.QuoteNumber})`);
    // eslint-disable-next-line max-len
    const editorState = htmlToEditorState(`<p>Hello,<br>TAI is pleased to send the attached bid for ${bidPdfDetailsData?.SiteName}</p><p>Regards<br>TAI Services, Inc.</p>`);
    setComment(editorState);
  }, [bidPdfDetailsData]);
  useEffect(() => {
    setValue('cc', userProfile?.Email?.trim());
  }, [userProfile]);

  // Function to get the HTML content from the editor
  const getHtmlFromEditorHTMLtoString = (newEditorState: EditorState): string => {
    const contentState = newEditorState.getCurrentContent();
    return stateToHTML(contentState);
  };

  const handleSendEmailError = (error: AxiosError<OilReportEmailResponse>) => {
    if (error?.response?.data?.BMT?.ResponseCode === 500) {
      setSendMailLoading(false);
      showErrorToaster(error?.response?.data?.BMT?.ResponseMessage);
    }
  };

  const handleComment = (newEditorState: EditorState) => {
    setComment(newEditorState);
  };

  const onSendEmail = async () => {
    const com = getHtmlFromEditorHTMLtoString(comment);
    const sendMail = getValues('to')?.trim()?.length > 0
          && getValues('Subject')?.trim()?.length > 0
          && com?.trim()?.length > 0;

    if (sendMail) {
      try {
        if (selectedPdf === null) {
          showErrorToaster('Please attach PDF to send mail.');
          return;
        }

        setSendMailLoading(true);

        // ✅ Generate PDF on the fly
        // const generatedPdf = await downloadPdf();

        // if (!generatedPdf) {
        //   showErrorToaster('Failed to generate PDF file.');
        //   setSendMailLoading(false);
        //   return;
        // }
        const formData = new FormData();

        formData.append('File', selectedPdf);
        // formData.append('File', generatedPdf);
        formData.append('RecieverMail', getValues('to') ?? '');
        formData.append('Subject', getValues('Subject') ?? '');
        formData.append('Body', com ?? '');
        formData.append('CcMail', getValues('cc') ?? '');
        formData.append('Type', '5');

        const token = localStorage.getItem(localStorageConstants.TOKEN);
        const userID = localStorage.getItem(localStorageConstants.USER_ID);

        if (!token || !userID) {
          throw new Error('Token or user ID is missing');
        }

        const axiosConfig = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `bearer ${token}`,
            LoginUserId: userID,
          },
        };

        const url = Config.oilReport.sendMail;

        const result = await makeFormPostRequest(url, formData, axiosConfig);
        showSuccessToaster('Email sent successfully');

        setSendMailLoading(false);
        dispatch(setLoader(false));
        handleClose();
        setSelectedPdf(null);
        return result.data;
      } catch (error) {
        setSendMailLoading(false);
        showErrorToaster('Oops! Kindly try sending mail after reloading the page');
        handleSendEmailError(error as AxiosError<OilReportEmailResponse>);
      }
    } else {
      showErrorToaster('Kindly enter Recipient emails, Subject and Body to send email.');
    }
  };

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      const fileSizeInKB = file.size / 1024; // Convert bytes to KB

      const allowedExtensions = ['pdf'];
      const maxSizeInKB = 5120; // 5 MB = 5120 KB

      if (!allowedExtensions.includes(fileExtension || '')) {
        showErrorToaster('Invalid file format. Please upload a PDF file (.pdf).');
      } else if (fileSizeInKB > maxSizeInKB) {
        showErrorToaster('File size exceeds 5MB. Please upload a smaller PDF.');
      } else {
        setSelectedPdf(file);
      }
    }

    const inputElement = event.target as HTMLInputElement;
    inputElement.value = ''; // Reset input
  };

  useEffect(() => {
    if (selectedPdf && selectedPdf?.name !== `${bidPdfDetailsData?.SiteName?.replace(/[\r\n]+/g, ' ')?.trim()} (${bidPdfDetailsData?.QuoteNumber}).pdf`) {
      setFileValidationModal(true);
    }
  }, [selectedPdf]);

  const setEmails = (e: React.FocusEvent<HTMLInputElement>) => {
    const toValue = e.target.value;
    if (toValue !== allReceiverEmails?.join(', ') && toValue?.length > 0) {
      setAllReceiverEmails(toValue?.split(',').map((email: string) => email.trim()).filter((email: string) => email !== ''));
    } else if (toValue?.length === 0) {
      setAllReceiverEmails([]);
    }
  };

  useEffect(() => {
    if (show) {
      if (allReceiverEmails?.length > 0) {
        setValue('to', allReceiverEmails?.join(', '));
        return;
      }
      setValue('to', '');
    }
  }, [allReceiverEmails, show]);

  const addReceiverEmail = (_alreadyAdded = true, email: string, _contactId: number) => {
    if (allReceiverEmails.includes(email)) {
      return;
    }
    setAllReceiverEmails([...allReceiverEmails, email]);
  };
  const handleData = () => {
    const payload = {
      customerId: bidPdfDetailsData?.CustomerId, searchQuery,
    };
    dispatch(getCustomerContactList(payload));
  };

  useEffect(() => {
    handleData();
  }, [searchQuery]);
  useEffect(() => {
    const contactData = CustomerContactList?.Data?.map((ele) => ({
      Name: `${ele?.FirstName} ${ele?.LastName}`,
      Email: ele?.Email,
      OilReport: ele?.OilReport,
      EctReport: ele?.EctReport,
      Id: ele?.ContactId,
    }));
    setData(contactData);
  }, [CustomerContactList?.Data]);

  return (
    <>
      <Modal
        open={show}
        onClose={() => { handleClose(); setSelectedPdf(null); }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="customerInfo_container flex-row">
            <div className="customerInfo">
              Send Bid Details
            </div>
            <div onClick={() => { handleClose(); setSelectedPdf(null); }}>
              <CloseIcon />
            </div>
          </div>

          <div className="container-fluid p-4 pb-0 customMobpad mob-pdfMailSystem">
            <div className="row">
              <div className="col-12 col-md-12">
                <div className="pdfEmailSystemContainer">
                  <div className="CustomTableContainer wd-50">
                    <div className="CustomSearchTable">
                      <TextField
                        className="subHeaderTextfield"
                        size="small"
                        placeholder="Search..."
                        onChange={(e) => setSearchQuery(e?.target?.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                      />
                    </div>
                    <div className="oilReportTableContainer">
                      <div className="oilReportTableHead mob-width-515">
                        {/* <div className="headerTableCell wd-15 text-end">
                        Oil
                      </div> */}
                        <div className="headerTableCell wd-15 text-end">
                          ECT
                        </div>
                        <div className="headerTableCell wd-25">
                          Name
                        </div>
                        <div className="headerTableCell wd-60">
                          Email
                        </div>
                      </div>
                      <div className="oilReportTableBody oilReportEmailBody noScroll mob-width-515">
                        <div className="oilReportTableList">
                          {data?.length > 0 && data?.map((element) => (
                            <div className="oilReportTableRowData">
                              {/* <div className="oilReportTableCell wd-15 justify-content-end">
                              {element?.OilReport ? <SelectedCheckBoxIcon /> : <CheckedIcon />}
                            </div> */}
                              <div className="oilReportTableCell wd-15 justify-content-end">
                                {element?.EctReport ? <SelectedCheckBoxIcon /> : <CheckedIcon />}
                              </div>
                              <div className="oilReportTableCell wd-25">
                                <div>{element?.Name}</div>
                              </div>
                              <div className="oilReportTableCell wd-60">
                                <div>{element?.Email}</div>
                                <div
                                  className="actionButtons"
                                  onClick={() => addReceiverEmail(element?.OilReport, element?.Email, element?.Id)}
                                  style={{ cursor: allReceiverEmails?.includes(element?.Email) ? 'not-allowed' : 'pointer' }}
                                >
                                  {allReceiverEmails?.includes(element?.Email) ? <DoubleArrowBlackIcon /> : <DoubleArrowGreenIcon />}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="customerInfo_main_container rightSideEmailBorderModal wd-50">
                    <div className="customScroll">
                      <Grid item xs={12} sm={12} md={12} className="bid_pdf_confirmation_body">
                        <Grid item md={12} sm={12} xs={12}>
                          <div className="div_label_text">
                            <label className="label_Style_job">To</label>
                            <ComponentTextInput
                              control={control}
                              name="to"
                              id="to"
                              size="small"
                              className="nonCapitalizeField"
                              handleBlur={setEmails}
                            />
                          </div>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                          <div className="div_label_text">
                            <label className="label_Style_job">CC</label>
                            <ComponentTextInput
                              control={control}
                              name="cc"
                              id="cc"
                              className="nonCapitalizeField"
                              size="small"
                            />
                          </div>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                          <div className="div_label_text">
                            <label className="label_Style_job">Subject</label>
                            <ComponentTextInput
                              control={control}
                              name="Subject"
                              id="Subject"
                              size="small"
                              className="nonCapitalizeField"
                            />
                          </div>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                          <div className="bid_pdf_confirmation_body_editorContainer">
                            <div className="attachmentButton">
                              <Input
                                type="file"
                                inputProps={{ accept: '.pdf', style: { display: 'none' } }}
                                id="fileInputEmail"
                                onChange={handleFileChange}
                              />
                              <label className="head">{selectedPdf?.name}</label>
                              <label htmlFor="fileInputEmail">
                                <Button variant="contained" component="span">
                                  <AttachmentIcon />
                                </Button>
                              </label>
                            </div>
                            <Editor
                              editorState={comment}
                              onEditorStateChange={handleComment}
                              wrapperClassName="demo-wrapper"
                              editorClassName="demo-editor"
                              localization={{ locale: 'en' }}
                              toolbar={customOptions}
                            />
                            {/* <label>{selectedPdf?.name}</label> */}
                          </div>
                        </Grid>
                      </Grid>

                    </div>
                  </div>

                </div>
              </div>
            </div>
            <Grid item md={12} sm={12} xs={12}>
              <div className="save_and_next_div mt10">
                <div>
                  <Button className="button_cancel" onClick={() => { handleClose(); setSelectedPdf(null); }}>Cancel</Button>
                </div>
                <div className="button_margin_left">
                  <Button
                    className="button_save_and_next"
                    onClick={onSendEmail}
                  >
                    Send
                  </Button>
                </div>
              </div>
            </Grid>
          </div>
        </Box>
      </Modal>
      {fileValidationModal && (
      <ConfirmationModal
        readOnly
        show={fileValidationModal}
        setOpenFrom={() => setFileValidationModal(false)}
        // eslint-disable-next-line max-len
        text={english.FileValidationMsg}
        confirmationIcon={<ConfirmationIcon />}
      />
      )}
    </>
  );
}

export default BidPdfEmailConfirmationModal;
